import type { ReactNode } from 'react';
import { useCallback } from 'react';

import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox, PrimaryLink } from '@/_components';

import { useGetIndustriesMutation } from '../apis';
import type { IndustryQueryLinkerSchema } from '../schemas';

export function IndustriesSelect({ disabled, ...props }: FormAsyncComboboxProps<IndustryQueryLinkerSchema>) {
  const getName = useCallback(
    (item?: IndustryQueryLinkerSchema | null): ReactNode => {
      if (!item) {
        return '';
      }

      const itemName = item.name;

      if (!disabled) {
        return itemName;
      }

      return (
        <PrimaryLink to="/settings/industries/$id" params={{ id: `${item.id}` }} state={{ naturalBack: true }}>
          {itemName}
        </PrimaryLink>
      );
    },
    [disabled]
  );

  return (
    <FormAsyncCombobox
      {...props}
      itemToString={getName}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      useApi={useGetIndustriesMutation}
      disabled={disabled}
    />
  );
}
